import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { PackageVisaStateType } from './types';
import { VISA_TYPES } from './constants';

const name = 'visa';

const initialState: PackageVisaStateType = {
  price: 0,
  docPrice: 0,
  policy: null,
  text: null,
  rules: null,
  type: VISA_TYPES.NO_VISA,
  purchasable: null,
};

// reducer
const visa = createSlice({
  name,
  initialState,
  reducers: {
    updateVisa(state, action: PayloadAction<PackageVisaStateType>) {
      // @ts-ignore
      if (typeof state?.toJS === 'function') {
        return {
          // @ts-ignore
          ...state.toJS(),
          ...action.payload,
        };
      }
      return { ...state, ...action.payload };
    },
  },
});

// actions
export const { updateVisa } = visa.actions;

export default visa.reducer;
